export default function (entitlements, serviceProviderId) {
  if (!Array.isArray(entitlements) || !serviceProviderId) return false;
  const foundEntitlement = entitlements.find(entitlement => entitlement.scopeId === `HA-${serviceProviderId}`);
  return (foundEntitlement && foundEntitlement.permission !== '') || false;
}



// WEBPACK FOOTER //
// ./src/app/common/utils/angiLeadsUtils.js